import React from 'react';
interface ICard {
  key?: number;
  svgIcon: React.ReactNode;
  title: string;
  paragraph: string;
  btnTitle: string;
  goTo?: any;
}
const QuickActionCard: React.FC<ICard> = ({ svgIcon, title, paragraph, btnTitle, goTo }) => {
  return (
    <div className='card-db'>
      <div className='card-db-header-col'>
        <div className='card-db-icon'>{svgIcon}</div>
        <div className='card-db-title'>{title}</div>
      </div>
      <div className='card-db-meta-col'>
        <span className='card-db-meta-span' style={{ textAlign: 'center' }}>
          {paragraph}
        </span>
      </div>
      <div className='card-db-actions-cnt'>
        <button className='screening-btn' onClick={goTo}>
          {btnTitle}
        </button>
      </div>
    </div>
  );
};
export default QuickActionCard;
